import gql from 'graphql-tag';

export const DELETE_SYMON_PIPE_CONFIGURATIONS = gql`
  mutation DeleteSymonPipeConfigurations($input: DeleteSymonPipeConfigurationsInput) {
    deleteSymonPipeConfigurations(input: $input)
  }
`;
